import ProgressBar from '@avalara/bat-apps-shared/client/components/ProgressBar';
import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { SCol, SRow, SContainer } from '@avalara/skylab-sdk/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectPlan } from '../../../store/order';
import { selectState } from '../../../selectors';
import { getSelectedPlanName } from '../../../selectors/order';
import { completePlanSelect } from '../../../lib/side-effects/offer-flow';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import { setCurrentOfferPage } from '../../../store/offer';
import AvataxSandboxPlanSelect from './avatax-sandbox';
import ExemptionsPlanSelect from './exemptions';
import IossPlanSelect from './ioss';
import { Pages } from '../../../../shared/types/offers';
import ShopifyConnectorPlanSelect from './avalara-for-shopify';
const OfferPlanSelect = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { offer: { offerFlow, plans, pages }, features, } = useSelector(selectState);
    const selectedPlanName = useSelector(getSelectedPlanName);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.Plans));
        dispatch(setProgressBarCurrentStep(stepNames.selectPlan));
    }, []);
    useEffect(() => {
        if (plans.length === 0)
            return;
        if (plans.length === 1 && !pages.includes(Pages.Plans)) {
            dispatch(completePlanSelect(plans[0], { shouldReplaceHistory: true, history }));
        }
        else {
            dispatch(selectPlan({ planName: selectedPlanName, planSelectComplete: false }));
        }
    }, [plans]);
    const showProgressbar = offerFlow !== 'avalara-for-shopify';
    const showShopifyConnector = features['AVALARA-FOR-SHOPIFY-FLOW'] ?
        React.createElement(ShopifyConnectorPlanSelect, { plans: plans }) : null;
    const getPlanSelectComponentForOffer = () => {
        switch (offerFlow) {
            case 'avatax-sandbox': return React.createElement(AvataxSandboxPlanSelect, { plans: plans });
            case 'exemptions': return React.createElement(ExemptionsPlanSelect, { plans: plans });
            case 'ioss': return React.createElement(IossPlanSelect, { plans: plans });
            case 'avalara-for-shopify': return showShopifyConnector;
            default: return null;
        }
    };
    return (React.createElement(SContainer, { role: 'main' },
        React.createElement(SRow, { className: 'pad-top-sm' },
            React.createElement(SCol, null, showProgressbar && React.createElement(ProgressBar, null))),
        getPlanSelectComponentForOffer()));
};
export default OfferPlanSelect;
